export const changeActiveSlide = slide => ({
    type: 'CHANGE_ACTIVE_SLIDE',
    slide
})

export const setSlides = slides => ({
    type: 'SET_SLIDES',
    slides
})

export const setLang = lang => ({
    type: 'SET_LANG',
    lang
})
export const setDisclaimer = disclaimer => ({
    type: 'SET_DISCLAIMER',
    disclaimer
})

export const setDrawerItems = items => ({
    type: 'SET_DRAWER_ITEMS',
    items
})

export const getSlidesEn = () => dispatch => {
    fetch('/traumahealinghope/assets/slides-en.json.txt')
        .then(res => res.json())
        .then(slides => dispatch(setSlides(slides)))
}

export const getSlidesFr = () => dispatch => {
    fetch('/traumahealinghope/assets/slides-fr.json.txt')
        .then(res => res.json())
        .then(slides => dispatch(setSlides(slides)))
}

export const getDisclaimerEn = () => dispatch => {
    fetch('/traumahealinghope/assets/disclaimer-en.txt')
        .then(res => res.text())
        .then(disclaimer => dispatch(setDisclaimer(disclaimer)))
}

export const getDisclaimerFr = () => dispatch => {
    fetch('/traumahealinghope/assets/disclaimer-fr.txt')
        .then(res => res.text())
        .then(disclaimer => dispatch(setDisclaimer(disclaimer)))
}

export const getDrawerEn = () => dispatch => {
    fetch('/traumahealinghope/assets/drawer-en.json.txt')
        .then(res => res.json())
        .then(items => dispatch(setDrawerItems(items)))
}

export const getDrawerFr = () => dispatch => {
    fetch('/traumahealinghope/assets/drawer-fr.json.txt')
        .then(res => res.json())
        .then(items => dispatch(setDrawerItems(items)))
}

export const startLang = lang => dispatch => {

    if(lang === 'en') {
        dispatch(getSlidesEn())
        dispatch(getDisclaimerEn())
        dispatch(getDrawerEn())
    } else if(lang === 'fr') {
        dispatch(getSlidesFr())
        dispatch(getDisclaimerFr())
        dispatch(getDrawerFr())
    }

    dispatch(setLang(lang))

}



// WEBPACK FOOTER //
// ./src/actions.js